import "./WorkTimeList.css";
import {useEffect, useState} from "react";
import axios from "axios";
import LoadingSpinner from "../../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import { FixedSizeList } from "rsuite/esm/Windowing";
import { Link } from "react-router-dom";
import { ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import extractTimeFromDateTime from "../../../../../sharedComponents/ExtractTimeFromDateTime";

function WorkTimeList() {

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [shifts, setShifts] = useState([]);

    useEffect(() => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("jwtToken");
        axios.get('activity/getLatestActivities?amount=10').then(results => {
            setShifts(results.data || []);
            setIsLoading(false);
        }).catch(() => {
            setHasError(true);
            setIsLoading(false);
        })
    }, [])

    const handleShiftClick = () => {
        sessionStorage.setItem("currentNavItem", "employees");
        sessionStorage.setItem("emplyoeeViewIndex", "0");
    }

    function generateShiftItems(props) {
        const { index, style } = props;
        const shift = shifts[index];
        const employee = shift.employee;

        if (shift.duration_working && shift.duration_in_pause) {
            return (
                <Link to={'/home/employees/employeeView?employeeId=' + employee.id} onClick={handleShiftClick}>
                    <ListItem style={style} key={index} component="div" disablePadding>
                    <ListItemButton>
                        <ListItemAvatar>
                            <CheckIcon className="work-time-list-check-icon"/>
                        </ListItemAvatar>
                        <ListItemText primary={employee.first_name + " " + employee.last_name + " - " + new Date(shift.start_time).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' }) + ": " + extractTimeFromDateTime(shift.start_time) + " bis " + extractTimeFromDateTime(shift.end_time)} secondary={"Arbeitszeit: " + shift.duration_working.hours + " Std. " + shift.duration_working.minutes + " Min. Pausenzeit: " + shift.duration_in_pause.hours + " Std. " + shift.duration_in_pause.minutes + " Min."} className="list-item-text" />
                    </ListItemButton>
                    </ListItem>
                </Link> 
            )
        }
    }

    if (isLoading) {
        return <LoadingSpinner/>
    }

    if (hasError) {
        return <p>Ein Fehler ist aufgetreten</p>
    }

    return <FixedSizeList
        className="work-time-list"
        height={400}
        width={"90%"}
        itemSize={60}
        itemCount={shifts.length}
        overscanCount={20}>
        {generateShiftItems}
    </FixedSizeList>
}

export default WorkTimeList;